export const artistKeys = {
  detail: (id: number) => ["artists", "detail", id] as const,
  overview: (id: number, signedIn: boolean) => ["artists", "overview", id, signedIn] as const,
};
